import moment from "moment"
import "moment/locale/pt-br"
moment.locale("pt-br")

export const getInactiveDates = (activationDate, disconnectDate) => {
  const hasDesactiveForMoreAYear =
    getMonthsBetween(activationDate, disconnectDate) >= 12
  if (hasDesactiveForMoreAYear) {
    return getDates(disconnectDate.substract(11, "months"), disconnectDate)
  }

  return getDates(activationDate, disconnectDate)
}

export const getActiveDates = (activationDate) => {
  const actualDate = moment()
  const hasActiveForMoreAYear =
    getMonthsBetween(activationDate, actualDate) >= 12

  if (hasActiveForMoreAYear) {
    return getDates(moment().subtract(11, "months"), actualDate)
  }

  return getDates(activationDate, actualDate)
}

const getMonthsBetween = (initialDate, endDate) => {
  const initialRange = moment([
    parseInt(initialDate.format("YYYY"), 10),
    parseInt(initialDate.format("MM"), 10) - 1
  ])
  const endRange = moment([
    parseInt(endDate.format("YYYY"), 10),
    parseInt(endDate.format("MM"), 10) - 1
  ])
  const months = Math.abs(initialRange.diff(endRange, "months", true) + 1)
  return months
}

const getDates = (initialDate, finalDate) => {
  const result = []
  const iterateDate = initialDate

  while (finalDate.startOf("day") >= iterateDate.startOf("day")) {
    const invoice = {
      paymentDate: iterateDate.format("MM/YYYY"),
      invoiceKey: iterateDate.format("YYYYMM")
    }

    result.unshift(invoice)
    iterateDate.add(1, "month")
  }

  return result
}



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/handleDates.js